import ProductDetailSection from './ProductDetailSection';
import { SearchProduct } from '@winelivery-org/wl-client-sdk-js/dist/models/search';
import { useTranslations } from 'next-intl';
import { Document as IconDocument } from '../../../../../components/icons';

interface Props {
  product: SearchProduct;
}

function ProductDetailSectionSpecifications({ product }: Props) {
  const t = useTranslations('shop');

  const items = [
    {
      label: t('detail.specifications.origin'),
      value: [product.country, product.region]
        .filter((value) => !!value)
        .map((value) => value!.name)
        .join(', '),
    },
    { label: t('detail.specifications.grapes'), value: product.grapes },
    {
      label: t('detail.specifications.alcohol'),
      value: product.alcohol || product.alcohol === 0 ? `${product.alcohol}%` : '' },
    {
      label: t('detail.specifications.characteristics'),
      value: product.characteristics
        ? product.characteristics.map((c) => c.name).join(', ')
        : null,
    },
    {
      label: t('detail.specifications.serviceTemperature'),
      value: product.serviceTemperature?.name,
    },
    { label: t('detail.specifications.color'), value: product.color },
    { label: t('detail.specifications.smell'), value: product.smell },
    { label: t('detail.specifications.taste'), value: product.taste },
    { label: t('detail.specifications.pairings'), value: product.pairings },
    { label: t('detail.specifications.allergens'), value: product.allergens },
    {
      label: t('detail.specifications.producerBusinessInfo'),
      value: product.producerBusinessInfo,
    },
  ].filter((item) => !!item.value);

  if (items.length === 0) {
    return null;
  }

  return (
    <ProductDetailSection title={t('detail.specifications.title')}>
      <dl className="m-0 p-0 ">
        {items.map((item, idx) => (
          <div
            className="sm:grid sm:grid-cols-3 sm:gap-8 py-2"
            key={idx}
          >
            <dt className="text-base font-medium text-greyscale-label tracking-tight">
              {item.label}
            </dt>
            <dd className="sm:col-span-2 m-0 mt-1 sm:mt-0 p-0 text-base font-medium text-greyscale-body tracking-tight">
              {item.value}
            </dd>
          </div>
        ))}
        {!!product.nutritionalValuesUrl ? (
          <div className="sm:grid sm:grid-cols-3 sm:gap-8 py-4">
            <dt className="text-base font-medium text-greyscale-label tracking-tight">
              {t('detail.specifications.attachments')}
            </dt>
            <dd className="sm:col-span-2 m-0 mt-1 sm:mt-0 p-0 text-base font-medium text-greyscale-body tracking-tight">
              <ul
                role="list"
                className="p-0 m-0 divide-y divide-greyscale-separator bg-greyscale-offwhite border border-greyscale-separator rounded-md overflow-hidden"
              >
                <li className="group">
                  <a
                    className="flex items-center gap-2 p-3 no-underline text-base font-medium tracking-tight text-greyscale-body group-hover:bg-greyscale-placeholder group-hover:text-greyscale-body"
                    href={product.nutritionalValuesUrl}
                    target="_blank"
                  >
                    <IconDocument />
                    <span>{t('detail.specifications.nutritionalValues')}</span>
                  </a>
                </li>
              </ul>
            </dd>
          </div>
        ) : null}
      </dl>
    </ProductDetailSection>
  );
}

export default ProductDetailSectionSpecifications;
